import { mapActions } from 'vuex'
import { ADD_PARTICIPATED_SURVEY } from '@/store/action-types'
import { USABILLA_ID } from '@/components/shared/feedback/feedback-constants'

const SCRIPT_TYPE = 'text/javascript'
const SCRIPT_ID = 'usabilla-widget-script'
export default {
  name: 'UsabillaContainer',
  data () {
    return {
      isLoading: true
    }
  },
  computed: {
    isNotLoading () {
      return !this.isLoading
    }
  },
  async mounted () {
    await this.loadScripts()
  },
  methods: {
    ...mapActions({
      addParticipatedSurvey: ADD_PARTICIPATED_SURVEY
    }),
    async loadScripts () {
      this.isLoading = true
      try {
        await this.loadOrInsertUsabillaScript()
        this.waitUntilUsabillaIsReady()
      } catch (error) {
        console.error('Error while trying to load usabilla script: ', error)
      } finally {
        this.isLoading = false
      }
    },
    loadOrInsertUsabillaScript () {
      return new Promise((resolve, reject) => {
        const existingUsabillaScript = document.querySelector(`#${SCRIPT_ID}`)
        if (existingUsabillaScript) {
          resolve()
        } else {
          const usabillaScript = this.createUsabillaScriptElement()
          usabillaScript.addEventListener('load', resolve)
          usabillaScript.addEventListener('error', reject)
          usabillaScript.addEventListener('abort', reject)

          document.body.appendChild(usabillaScript)
        }
      })
    },
    waitUntilUsabillaIsReady () {
      const { usabilla } = window
      if (!usabilla) {
        console.error('window.usabilla is undefined')
      } else {
        window.usabillaSetEventCallbacks =
          window.usabillaSetEventCallbacks || {}
      }
    },
    createUsabillaScriptElement () {
      const usabillaScript = document.createElement('script')
      usabillaScript.id = SCRIPT_ID
      usabillaScript.type = SCRIPT_TYPE
      usabillaScript.async = true
      usabillaScript.src = '/usabilla.widget.js'
      return usabillaScript
    },
    widgetMounted (widgetId) {
      window.usabilla.load('w.usabilla.com', USABILLA_ID)
      // check if callback has already been set, if not set it
      if (!window.usabillaSetEventCallbacks[widgetId]) {
        window.usabilla('setEventCallback', () => {
          // when user interacts with widget in any way, commit to store
          this.addParticipatedSurvey(widgetId)
        })
        // record that callback for this widget has been set
        window.usabillaSetEventCallbacks[widgetId] = true
      }
    }
  },
  render () {
    return this.$scopedSlots.default({
      usabillaIsDoneLoading: this.isNotLoading,
      widgetMounted: this.widgetMounted
    })
  }
}
